export default function parentNodes(el) {
  return el.parentNode ? [el.parentNode, ...parentNodes(el.parentNode)] : [];
};
